import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import useAppSelector from '@hooks/useAppSelector';
import { environmentSelector } from '@selectors/commonSelectors';

// Components

import AlertInfo from '@components/common/alert/AlertInfo';
import Form from '@lib/wrappers/Form';
import UniversalInput from '@lib/wrappers/UniversalInput';

// Action creators

import { changeData } from '@actions/ssap/ssapActionCreators';

// Utils

import { cleanUpSsapJson } from '@utils/miscellaneous/cleanUpSsapJson';
import { cloneDeep, set } from '@utils/miscellaneous/objectHelpers';
import { parseFieldChangeArgs } from '@utils/ssap/parseFieldChangeArgs';

// Constants

import { DROPDOWN_OPTIONS } from '@constants/ssap/hhmTypes/dropdownOptions';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import { VALIDATION_TYPES } from '@constants/inputs/validationTypes';
import { PROPS_LIST_FOR_SSAP_JSON_CLEANING } from '@constants/ssap/initialValues/propsListForSsapJsonCleaning';


const Page1_03_E1 = props => {

    const {
        data,
        data: {
            applyingForFinancialAssistanceIndicator
        },
        formName,
        page
    } = props;
    const { exchangeName } = useAppSelector(environmentSelector);
    
    const onFieldChange = (...args) => {

        let { newData, value } = parseFieldChangeArgs(args);

        if(!value) {
            newData = cleanUpSsapJson(newData, { ...PROPS_LIST_FOR_SSAP_JSON_CLEANING, maxAchievedPage: page });
        } else {
            newData = set(cloneDeep(newData), 'taxHousehold.thCommonParams.hasTaxFilers', null);
        }
        props.actions.changeData(newData);
    };

    return (
        <Fragment>
            <div id="saHelpPayingForCoverage" className="fade-in">
                <div className="subsection">
                    <strong className="h3 gi-heading-alt">
                        <FormattedMessage id="ssap.start.help_paying.notification" values={{ exchangeName }}/>
                    </strong>

                    <Form { ...{ formName } }>
                        <UniversalInput
                            legend={{
                                legendText: 'ssap.input.legend.help_paying'
                            }}
                            label={{
                                labelClass: [''],
                                ulClass: [''],
                                showRequiredIcon: true
                            }}
                            inputData={{
                                isInputRequired: true,
                                type: INPUT_TYPES.RADIO_BUTTONS,
                                name: 'applyingForFinancialAssistanceIndicator',
                                value: applyingForFinancialAssistanceIndicator,
                                options: DROPDOWN_OPTIONS.FLOW_TYPE,
                                optionsReplacements: { exchangeName },
                                validationType: VALIDATION_TYPES.CHOSEN,
                                currentData: data,
                                fields: []

                            }}
                            errorClasses={['margin-l-0']}
                            inputActions={{
                                onFieldChange
                            }}
                        />

                        {
                            applyingForFinancialAssistanceIndicator === false &&

                            <AlertInfo id = 'ssap.start.help_paying.no_selection_alert' />
                        }
                    </Form>
                </div>
            </div>
        </Fragment>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data,
    page: state.ssap.page
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Page1_03_E1);
